/**
 * Vite-safe base64url encoder.
 *
 * Replaces the `base64url` npm package, which encodes via Node's `Buffer`.
 * Webpack auto-polyfills `Buffer`, so the package works on the Bridge/webpack
 * line today — but Vite (the Nuxt 4 target) does NOT polyfill `Buffer`, so the
 * package would break the build the moment the app compiles under Vite. This
 * helper uses only `TextEncoder` + `btoa`, both of which are global in browsers
 * AND in Node 18 (so it works under MSW's `setupWorker` and `setupServer`).
 *
 * Output is byte-identical to `base64url(str)` for string input (utf8 bytes →
 * base64 → url-safe alphabet, padding stripped). Verified against the package
 * across ASCII, numeric, empty, and multi-byte-utf8 inputs.
 */
export function base64UrlEncode(input: string): string {
  const bytes = new TextEncoder().encode(input)
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}
